// extracted by mini-css-extract-plugin
export default {"container":"titleLoading-module__container__UDoVw","containerMobile":"titleLoading-module__containerMobile__qr6W9"};